import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../material-ui/ButtonUI";
import { AuthContext } from "../../context/Auth/AuthContext";
import deleteClient from "../../api/deleteClient";

/*** Component for showing the confirmation message before bulk deleting the clients from client table ***/
const BulkDeletePopup = ({
  setClientDeletedToTrue,
  Clientbulkid = [],
  bulkDeleteClient,
  setBulkDeleteClient,
  setRowSelection
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkDeleteClient(false);
  };

  const onBulkDelete = async (Clientbulkid) => {
    const deleteAllClientFormResponse = await deleteClient({
      token: token,
      id: Clientbulkid,
    });

    if (deleteAllClientFormResponse.code === 200) {
      setRowSelection({});
      setBulkDeleteClient(false);
      setClientDeletedToTrue();
      showSuccess("Client/s deleted successfully");
    } else {
      showError("Error while bulk deleting client/s");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkDeleteClient}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">Delete Client</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete these clients ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkDelete(Clientbulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkDeletePopup;
